<template>
    <div class="creative-preview">
        <h2>Creative Preview</h2>
        <div class="creative-preview-box">
            <div class="creative-preview-box__lender-name">
                <label>{{ lender }}</label>
                <p>PRODUCT TYPE | MEMBER FDIC</p>
            </div>
            <div class="creative-preview-box__logo">
                <label>LOGO</label>
                <div class="creative-preview-box__square"></div>
                <div class="creative-preview-box__logo--image">
                    <img v-if="advertiser.logo" :src="logoSrc">
                </div>
            </div>
            <div class="creative-preview-box__apr">
                <label>APR</label>
                <div class="creative-preview-box__square"></div>
                <div class="creative-preview-box__price">
                    <label>X.XX
                        <span class="numeral_accent --right">%</span>
                    </label>
                </div>
                <p>4.000% Rate | At 0 pts</p>
            </div>
            <div class="creative-preview-box__est-payment">
                <label>Estimated Payment</label>
                <div class="creative-preview-box__square"></div>
                <div class="creative-preview-box__price">
                    <label>
                        <span class="numeral_accent --left">$</span>X.XXX</label>
                </div>
                <p>As of Mon Oct 10</p>
            </div>
            <div class="creative-preview-box__contact">
                <div class="creative-preview-box__contact__next">
                    <label>Contact Number</label>
                    <button type="button" class="btn --green">NEXT <btn-right-arrow /></button>
                </div>
                <div class="creative-preview-box__square"></div>
                <div class="creative-preview-box__contact__number">
                    XXX-XXX-XXXX
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['advertiser'],
    computed: {
        lender() {
            return this.advertiser.lender ? this.advertiser.lender : "Lender's Name";
        },
        logoSrc() {
            return `http://www.brimg.net/system/img/inst/${this.advertiser.logo}`;
        }
    }
}
</script>
